import LoadingOverlay from "react-loading-overlay";
import { ClockLoader } from "react-spinners";
import styled, { css } from "styled-components";
import "./CsplLoader.module.css";

const DarkBackground = styled.div`
  display: none; /* Hidden by default */
  position: fixed; /* Stay in place */
  z-index: ${(props) => props.zIndex ?? 10001}; /* Sit on top */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  background-color: rgb(0, 0, 0); /* Fallback color */
  background-color: rgba(0, 0, 0, 0.4); /* Black w/ opacity */

  ${(props) =>
    props.disappear &&
    css`
      display: block; /* show */
    `}
`;

function CsplBackDropLoading(props) {
  return (
    <DarkBackground disappear={props.showLoading} zIndex={props.zIndex}>
      <LoadingOverlay
        active={true}
        spinner={<ClockLoader color={"#ffffff"} />}
        // spinner={true}
        text="Loading ..."
      ></LoadingOverlay>
    </DarkBackground>
  );
}

export default CsplBackDropLoading;
